import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { RouterService } from '../services/router.service';
import { UserService } from '../services/user.service';
import { GuardAuthentication } from './guardAuthentication';

@Injectable({ providedIn: 'root' })
export class GuardOrdering extends GuardAuthentication {
    constructor(
        protected userService: UserService,
        protected router: Router,
        protected routerService: RouterService
    ) {
        super(userService, routerService);
    }

    public canLoad(route: Route): boolean | Observable<boolean> | Promise<boolean> {
        const url = `/${route.path}`;

        return this.checkLogin(url);
    }

    public canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(childRoute, state);
    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const url = '/';

        if (!this.checkLogin(url)) {
            return false;
        }

        return true;
    }
}
